import React, { useState } from 'react'
import { withRouter } from 'react-router-dom'

import CartSidebar from './CartSidebar'

import { USE_RICH_CHECKOUT } from '../constants'

const ConcessionsCartSidebar = ({ history, hasCartItems, className }) => {
  const [showCardReaderModal, setShowCardReaderModal] = useState(false)

  const onCardPayment = () => {
    if (USE_RICH_CHECKOUT === 'true') return history.push('/pos-rich-checkout')

    return setShowCardReaderModal(true)
  }

  const topButton = {
    text: "Cash Payment",
    disabled: !hasCartItems,
    onClick: () => history.push('/change-calculator')
  }

  const bottomButton = {
    text: "Card Payment",
    disabled: !hasCartItems,
    onClick: onCardPayment,
  }

  return (
    <CartSidebar
      topButton={topButton}
      bottomButton={bottomButton}
      hasCartItems={hasCartItems}
      showCardReaderModal={showCardReaderModal}
      onCardReaderModalClose={setShowCardReaderModal}
      className={className}
    />
  )
}

export default withRouter(ConcessionsCartSidebar)
